/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutTrackingListEntryPayer } from './CarveOutTrackingListEntryPayer';
import {
    CarveOutTrackingListEntryPayerFromJSON,
    CarveOutTrackingListEntryPayerFromJSONTyped,
    CarveOutTrackingListEntryPayerToJSON,
    CarveOutTrackingListEntryPayerToJSONTyped,
} from './CarveOutTrackingListEntryPayer';
import type { CarveOutTrackingRowStatus } from './CarveOutTrackingRowStatus';
import {
    CarveOutTrackingRowStatusFromJSON,
    CarveOutTrackingRowStatusFromJSONTyped,
    CarveOutTrackingRowStatusToJSON,
    CarveOutTrackingRowStatusToJSONTyped,
} from './CarveOutTrackingRowStatus';
import type { PalAuthPlatformPayorForm } from './PalAuthPlatformPayorForm';
import {
    PalAuthPlatformPayorFormFromJSON,
    PalAuthPlatformPayorFormFromJSONTyped,
    PalAuthPlatformPayorFormToJSON,
    PalAuthPlatformPayorFormToJSONTyped,
} from './PalAuthPlatformPayorForm';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
    PalAuthSubmissionStatusToJSONTyped,
} from './PalAuthSubmissionStatus';
import type { PalAuthPlatform } from './PalAuthPlatform';
import {
    PalAuthPlatformFromJSON,
    PalAuthPlatformFromJSONTyped,
    PalAuthPlatformToJSON,
    PalAuthPlatformToJSONTyped,
} from './PalAuthPlatform';
import type { CarveOutTrackingListEntryLead } from './CarveOutTrackingListEntryLead';
import {
    CarveOutTrackingListEntryLeadFromJSON,
    CarveOutTrackingListEntryLeadFromJSONTyped,
    CarveOutTrackingListEntryLeadToJSON,
    CarveOutTrackingListEntryLeadToJSONTyped,
} from './CarveOutTrackingListEntryLead';
import type { CarveOutAttemptChannel } from './CarveOutAttemptChannel';
import {
    CarveOutAttemptChannelFromJSON,
    CarveOutAttemptChannelFromJSONTyped,
    CarveOutAttemptChannelToJSON,
    CarveOutAttemptChannelToJSONTyped,
} from './CarveOutAttemptChannel';
import type { PalAuthSubmissionStatusInfo } from './PalAuthSubmissionStatusInfo';
import {
    PalAuthSubmissionStatusInfoFromJSON,
    PalAuthSubmissionStatusInfoFromJSONTyped,
    PalAuthSubmissionStatusInfoToJSON,
    PalAuthSubmissionStatusInfoToJSONTyped,
} from './PalAuthSubmissionStatusInfo';
import type { CarveOutMedicationSummary } from './CarveOutMedicationSummary';
import {
    CarveOutMedicationSummaryFromJSON,
    CarveOutMedicationSummaryFromJSONTyped,
    CarveOutMedicationSummaryToJSON,
    CarveOutMedicationSummaryToJSONTyped,
} from './CarveOutMedicationSummary';

/**
 * 
 * @export
 * @interface CarveOutTrackingListEntry
 */
export interface CarveOutTrackingListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    status: PalAuthSubmissionStatus;
    /**
     * 
     */
    status_info?: PalAuthSubmissionStatusInfo;
    /**
     * 
     */
    carve_out_status: CarveOutTrackingRowStatus;
    /**
     * 
     */
    lead?: CarveOutTrackingListEntryLead;
    /**
     * 
     */
    payer?: CarveOutTrackingListEntryPayer;
    /**
     * 
     */
    auth_platform_form?: PalAuthPlatformPayorForm;
    /**
     * All non-deleted carve-out medications on this submission, cancelled ones last.
     */
    medications: Array<CarveOutMedicationSummary>;
    /**
     * Sum of cost_per_day across this submission's non-deleted, non-cancelled carve-out medications.
     */
    total_daily_cost: number;
    /**
     * Distinct channels of this submission's non-failed carve-out submission attempts.
     */
    sent_channels?: Array<CarveOutAttemptChannel>;
    /**
     * Distinct portals used by this submission's non-failed portal_rpa carve-out attempts. Attempts recorded before the portal was stored fall back to the submission's current portal form.
     */
    sent_auth_platforms?: Array<PalAuthPlatform>;
}



/**
 * Check if a given object implements the CarveOutTrackingListEntry interface.
 */
export function instanceOfCarveOutTrackingListEntry(value: object): value is CarveOutTrackingListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('carve_out_status' in value) || value['carve_out_status'] === undefined) return false;
    if (!('medications' in value) || value['medications'] === undefined) return false;
    if (!('total_daily_cost' in value) || value['total_daily_cost'] === undefined) return false;
    return true;
}

export function CarveOutTrackingListEntryFromJSON(json: any): CarveOutTrackingListEntry {
    return CarveOutTrackingListEntryFromJSONTyped(json, false);
}

export function CarveOutTrackingListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'status': PalAuthSubmissionStatusFromJSON(json['status']),
        'status_info': json['status_info'] == null ? undefined : PalAuthSubmissionStatusInfoFromJSON(json['status_info']),
        'carve_out_status': CarveOutTrackingRowStatusFromJSON(json['carve_out_status']),
        'lead': json['lead'] == null ? undefined : CarveOutTrackingListEntryLeadFromJSON(json['lead']),
        'payer': json['payer'] == null ? undefined : CarveOutTrackingListEntryPayerFromJSON(json['payer']),
        'auth_platform_form': json['auth_platform_form'] == null ? undefined : PalAuthPlatformPayorFormFromJSON(json['auth_platform_form']),
        'medications': ((json['medications'] as Array<any>).map(CarveOutMedicationSummaryFromJSON)),
        'total_daily_cost': json['total_daily_cost'],
        'sent_channels': json['sent_channels'] == null ? undefined : ((json['sent_channels'] as Array<any>).map(CarveOutAttemptChannelFromJSON)),
        'sent_auth_platforms': json['sent_auth_platforms'] == null ? undefined : ((json['sent_auth_platforms'] as Array<any>).map(PalAuthPlatformFromJSON)),
    };
}

export function CarveOutTrackingListEntryToJSON(json: any): CarveOutTrackingListEntry {
    return CarveOutTrackingListEntryToJSONTyped(json, false);
}

export function CarveOutTrackingListEntryToJSONTyped(value?: CarveOutTrackingListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'status': PalAuthSubmissionStatusToJSON(value['status']),
        'status_info': PalAuthSubmissionStatusInfoToJSON(value['status_info']),
        'carve_out_status': CarveOutTrackingRowStatusToJSON(value['carve_out_status']),
        'lead': CarveOutTrackingListEntryLeadToJSON(value['lead']),
        'payer': CarveOutTrackingListEntryPayerToJSON(value['payer']),
        'auth_platform_form': PalAuthPlatformPayorFormToJSON(value['auth_platform_form']),
        'medications': ((value['medications'] as Array<any>).map(CarveOutMedicationSummaryToJSON)),
        'total_daily_cost': value['total_daily_cost'],
        'sent_channels': value['sent_channels'] == null ? undefined : ((value['sent_channels'] as Array<any>).map(CarveOutAttemptChannelToJSON)),
        'sent_auth_platforms': value['sent_auth_platforms'] == null ? undefined : ((value['sent_auth_platforms'] as Array<any>).map(PalAuthPlatformToJSON)),
    };
}

